import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    font-family: ${(props) => props.theme.font.family};
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background-color: ${(props) => props.theme.colors.surface.low};
    color: ${(props) => props.theme.colors.text.primary};
    overscroll-behavior: contain;
    overflow-y: auto;
  }

  a {
    color: ${(props) => props.theme.colors.text.secondary};
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: ${(props) => props.theme.colors.button.hover.primary};
    }
  }

  button {
    font-family: ${(props) => props.theme.font.family};
    background-color: ${(props) => props.theme.colors.button.surface.primary};
    color: ${(props) => props.theme.colors.button.text.primary};
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: ${(props) => props.theme.colors.button.hover.primary};
    }

    &:disabled {
      background-color: ${(props) => props.theme.colors.button.surface.disabled};
      color: ${(props) => props.theme.colors.button.text.disabled};
      cursor: not-allowed;
    }
  }

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.surface.base};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.accent.primary};
    border-radius: 6px;
    border: 3px solid ${(props) => props.theme.colors.surface.base};
  }

  * {
    scrollbar-color: ${(props) => props.theme.colors.border} ${(props) => props.theme.colors.surface.base};
    scrollbar-width: thin;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Elza', sans-serif;
  }

  ${props => props.theme.media.mobile} {
    body {
      font-size: ${(props) => props.theme.font.sizes.small};
    }

    h1, h2, h3, h4, h5, h6 {
      font-size: ${(props) => props.theme.font.sizes.medium};
    }
  }
`;
